import React, { useState, useEffect } from "react";
import { Form, Image } from "react-bootstrap";
import moment from "moment";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";

import UserFavoritesRestaurant from "./InsidePageComponent/UserFavoritesRestaurant";
import UserFavoritesOffers from "./InsidePageComponent/UserFavoritesOffers";
import UserFavoritesEvents from "./InsidePageComponent/UserFavoritesEvents";
import { Button, Col } from "react-bootstrap";
import UserFavoritesLiveStreaming from "./InsidePageComponent/UserFavoritesLiveStreaming";
import UserItemActivity from "./InsidePageComponent/UserItemActivity";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import UserTrackVideo from "./InsidePageComponent/UserTrackVideo";
import UserFavoriteReels from "./InsidePageComponent/UserFavoriteReels";


// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations

const offer_filters = [
  { title: "Online", value: 0 },
  { title: "Offline", value: 1 },
];

const live_streaming_filters = [
  { title: "Youtube", value: 0 },
  { title: "Instagram", value: 1 },
  { title: "Facebook", value: 2 },
  { title: "LinkedIn", value: 3 },
];

const SuperAdminUserViewUsed = (props) => {
  const [selectedTab, setSelectedTab] = useState(1);
  const [filter, setFilter] = useState(false);

  const pageChangeButtonHandler = (value) => {
    setFilter(false);
    setFilterOption("");
    setSelectedTab(value);
  };
  const [state, setState] = useState({
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    showFilter: false,
  });

  /*********************************
   * @DESC Search Bar Action
   *********************************/
  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  const [dateQuery, setDateQuery] = useState({});

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    setState({
      ...state,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  // Filter option
  const [filterOptionTemp, setFilterOptionTemp] = useState("");
  const [filterOption, setFilterOption] = useState("");

  const [restaurantReport, setRestaurantReport] = useState([]);
  const [offersReport, setOffersReport] = useState([]);
  const [eventsReport, setEventsReport] = useState([]);
  const [liveStreamingReport, setLiveStreamingReport] = useState([]);
  const [itemsReport, setItemsReport] = useState([]);
  const [reelsReport, setReelsReport] = useState([]);

  useEffect(() => {
    setRestaurantReport(props?.userRestaurantActivity?.data);
    setOffersReport(props?.userOfferActivity?.data);
    setEventsReport(props?.userEventActivity?.data);
    setLiveStreamingReport(props?.userStreamingActivity?.data);
    setItemsReport(props?.userItemActivity?.data);
    setReelsReport()
  }, [
    props.userRestaurantActivity,
    props?.userOfferActivity,
    props?.userEventActivity,
    props?.userStreamingActivity,
    props?.userItemActivity,
  ]);

  // Restaurant Download Data
  const restaurantDownloadData = {
    headers: [
      { label: "Business ID", key: "businessID" },
      { label: "Business Name", key: "businessName" },
      { label: "User ID", key: "userID" },
      { label: "User Name", key: "userName" },
      { label: "Date & Time", key: "dateTime" },
      ,
    ],
    data: restaurantReport
      ? restaurantReport.map((ele) => {
          return {
            businessID: ele?.restaurant_id?._id,
            businessName: `${ele?.restaurant_id?.restaurant_name || ""} \n ${
              ele?.restaurant_id?.area || ""
            }`,
            userID:
              ele?.user_id !== undefined && ele?.user_id !== null
                ? ele?.user_id?._id
                : "",
            userName: `${
              ele?.user_id !== undefined && ele?.user_id !== null
                ? ele?.user_id?.first_name + " " + ele?.user_id?.last_name
                : ""
            }`,
            dateTime: `${
              moment(ele?.createdAt).format("Do MMM, YYYY") || ""
            } \n ${moment(ele?.createdAt).format("hh:mm A") || ""}`,
          };
        })
      : [],
  };

  // Offers Download Data
  const offersDownloadData = {
    headers: [
      { label: "Offer ID", key: "offerID" },
      { label: "Offer Name", key: "offerName" },
      { label: "Offer Description", key: "offerDescription" },
      { label: "Offer Type", key: "offerOnline" },
      { label: "User ID", key: "userID" },
      { label: "User Name", key: "userName" },
      { label: "Date & Time", key: "dateTime" },
      { label: "Offer View", key: "offerView" },
      { label: "Offer Used", key: "offerUsed" },
      { label: "Restaurant ID", key: "restaurantID" },
      { label: "Restaurant Name", key: "restaurantName" },
      ,
    ],
    data: offersReport
      ? offersReport?.map((ele) => {
          return {
            offerID: ele?.offer_id?._id,
            offerName: `${ele?.offer_id?.name}`,
            offerDescription: `${ele?.offer_id?.description}`,
            offerOnline: `${ele?.offer_id?.isOnline ? "Online" : "Offline"}`,
            userID:
              ele?.user_id !== undefined && ele?.user_id !== null
                ? ele?.user_id?._id
                : "",
            userName: `${
              ele?.user_id !== undefined && ele?.user_id !== null
                ? ele?.user_id?.first_name + " " + ele?.user_id?.last_name
                : ""
            }`,
            dateTime: `${
              moment(ele?.createdAt).format("Do MMM, YYYY") || ""
            } \n ${moment(ele?.createdAt).format("hh:mm A") || ""}`,
            offerView: `${ele?.viewed ? "Yes" : "No"}`,
            offerUsed: `${ele?.used ? "Yes" : "No"}`,
            restaurantID: ele?.restaurant_id?._id,
            restaurantName: `${ele?.restaurant_id?.restaurant_name || ""} \n ${
              ele?.restaurant_id?.area || ""
            }`,
          };
        })
      : [],
  };

  // Event Download Data
  const eventDownloadData = {
    headers: [
      { label: "Event ID", key: "eventID" },
      { label: "Event Name", key: "eventName" },
      { label: "Event Description", key: "eventDescription" },
      { label: "Event Type", key: "eventOnline" },
      { label: "User ID", key: "userID" },
      { label: "User Name", key: "userName" },
      { label: "Date & Time", key: "dateTime" },
      { label: "Event View", key: "eventView" },
      { label: "Event Used", key: "eventUsed" },
      { label: "Restaurant ID", key: "restaurantID" },
      { label: "Restaurant Name", key: "restaurantName" },
      ,
    ],
    data: eventsReport
      ? eventsReport?.map((ele) => {
          return {
            eventID: ele?.event_id?.event_id,
            eventName: `${ele?.event_id?.name}`,
            eventDescription: `${ele?.event_id?.description}`,
            eventOnline: `${ele?.event_id?.isOnline ? "Online" : "Offline"}`,
            userID:
              ele?.user_id !== undefined && ele?.user_id !== null
                ? ele?.user_id?._id
                : "",
            userName: `${
              ele?.user_id !== undefined && ele?.user_id !== null
                ? ele?.user_id?.first_name + " " + ele?.user_id?.last_name
                : ""
            }`,
            dateTime: `${
              moment(ele?.createdAt).format("Do MMM, YYYY") || ""
            } \n ${moment(ele?.createdAt).format("hh:mm A") || ""}`,
            eventView: `${ele?.viewed ? "Yes" : "No"}`,
            eventUsed: `${ele?.used ? "Yes" : "No"}`,
            restaurantID: ele?.restaurant_id?._id,
            restaurantName: `${ele?.restaurant_id?.restaurant_name || ""} \n ${
              ele?.restaurant_id?.area || ""
            }`,
          };
        })
      : [],
  };

  // Live Streaming Download Data
  const liveStreamingDownloadData = {
    headers: [
      { label: "Restaurant ID", key: "restaurantID" },
      { label: "Restaurant Name", key: "restaurantName" },
      { label: "User ID", key: "userID" },
      { label: "User Name", key: "userName" },
      { label: "Date & Time", key: "dateTime" },
      { label: "Live Stream View", key: "liveStreamView" },
      { label: "Live Stream", key: "liveStream" },
      ,
    ],
    data: liveStreamingReport
      ? liveStreamingReport?.map((ele) => {
          return {
            restaurantID: ele?.restaurant_id?._id,
            restaurantName: `${ele?.restaurant_id?.restaurant_name || ""} \n ${
              ele?.restaurant_id?.area || ""
            }`,
            userID:
              ele?.user_id !== undefined && ele?.user_id !== null
                ? ele?.user_id?._id
                : "",
            userName: `${
              ele?.user_id !== undefined && ele?.user_id !== null
                ? ele?.user_id?.first_name + " " + ele?.user_id?.last_name
                : ""
            }`,
            dateTime: `${
              moment(ele?.createdAt).format("Do MMM, YYYY") || ""
            } \n ${moment(ele?.createdAt).format("hh:mm A") || ""}`,
            liveStreamView: `${ele?.viewed ? "Yes" : "No"}`,
            liveStream: `${ele?.liveStream ? "Yes" : "No"}`,
          };
        })
      : [],
  };

  // Items Download Data
  const itemsDownloadData = {
    headers: [
      { label: "Restaurant ID", key: "restaurantID" },
      { label: "Restaurant Name", key: "restaurantName" },
      { label: "Item ID", key: "itemID" },
      { label: "Item Name", key: "itemName" },
      { label: "User ID", key: "userID" },
      { label: "User Name", key: "userName" },
      { label: "Date & Time", key: "dateTime" },
      { label: "Item View", key: "itemView" },
      { label: "Item Ordered", key: "itemOrdered" },
      ,
    ],
    data: itemsReport
      ? itemsReport?.map((ele) => {
          return {
            restaurantID: ele?.restaurant_id?._id,
            restaurantName: `${ele?.restaurant_id?.restaurant_name || ""} \n ${
              ele?.restaurant_id?.area || ""
            }`,
            itemID: ele?.item_id?._id,
            itemName: `${ele?.item_id?.name}`,
            userID:
              ele?.user_id !== undefined && ele?.user_id !== null
                ? ele?.user_id?._id
                : "",
            userName: `${
              ele?.user_id !== undefined && ele?.user_id !== null
                ? ele?.user_id?.first_name + " " + ele?.user_id?.last_name
                : ""
            }`,
            dateTime: `${
              moment(ele?.createdAt).format("Do MMM, YYYY") || ""
            } \n ${moment(ele?.createdAt).format("hh:mm A") || ""}`,
            itemView: `${ele?.viewed ? "Yes" : "No"}`,
            itemOrdered: `${ele?.used ? "Yes" : "No"}`,
          };
        })
      : [],
  };

  const [showSearch, setShowSearch] = useState(false);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="left-side-panel">
          <LeftSideNavigation displayLink={1} />
        </div>
        <div className="super-admin-right-side-panel">
          <HomeReusableTopBarNavigation
            displayBack={true}
            backButtonLink="/superadmindashboard"
            displayText="User Views/Used"
          />
          <Col>
            <Col className="d-flex justify-content-between align-items-center pt-4 pb-3">
              <div className="f24_700_HelveticaNeue">
                User Views / Used Activity Report
              </div>
            </Col>
          </Col>
          <Col className="px-4">
            <div className="row">
              <div className="col-3">
                <div className="d-flex align-items-center">
                  <Image
                    onClick={() =>
                      // this.setState({ showSearch: !this.state.showSearch })
                      setShowSearch(!showSearch)
                    }
                    alt="filter"
                    title="filter"
                    width="80px"
                    src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                  />

                  <SortComponent
                    handleClick={handleClick}
                    anchorEl={state.anchorEl}
                    handleClose={handleClose}
                    selectClick={(data) => handleSelect(data)}
                  />
                {selectedTab !== 6 && (
                <>
                  <div
                    className="f10-400"
                    align="center"
                    onClick={() => {
                      if (
                        selectedTab === 4 ||
                        selectedTab === 2 ||
                        selectedTab === 3
                      )
                        setFilter(!filter);
                    }}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      alt="Filter Icon"
                      width="80"
                    />
                    {/* <br />
                    Filter */}
                  </div>
                </>
                ) }  
              
                  <CSVDownloader
                    filename={
                      selectedTab === 1
                        ? "Resaurant Used Activity Report"
                        : selectedTab === 2
                        ? "Offers Used Activity Report"
                        : selectedTab === 3
                        ? "Events Used Activity Report"
                        : selectedTab === 4
                        ? "Live Streaming Used Activity Report"
                        : "Items Used Activity Report"
                    }
                    headers={
                      selectedTab === 1
                        ? restaurantDownloadData.headers
                        : selectedTab === 2
                        ? offersDownloadData.headers
                        : selectedTab === 3
                        ? eventDownloadData.headers
                        : selectedTab === 4
                        ? liveStreamingDownloadData.headers
                        : itemsDownloadData.headers
                    }
                    data={
                      selectedTab === 1
                        ? restaurantDownloadData.data
                        : selectedTab === 2
                        ? offersDownloadData.data
                        : selectedTab === 3
                        ? eventDownloadData.data
                        : selectedTab === 4
                        ? liveStreamingDownloadData.data
                        : itemsDownloadData.data
                    }
                  />
                  {/* <div className="f10-400" align="center">
                    <img
                      src={require("../../../../assets/images/iconButton/downloadicon.png")}
                      width="35px"
                      alt="Download Icon"
                    />
                    <br />
                    Download
                  </div> */}
                </div>
              </div>
              <div className="col-6"></div>
              <div className="col-3">
                <div className="mr-3">
                  <SelectFilter onDateChange={onDateChangeHandler} />
                </div>
              </div>
              <div className="col-2"></div>
            </div>
          </Col>
          {showSearch && (
            <div className="mb-3">
              <ZoomDiv>
                <>
                  <br />
                  <Form.Control
                    type="text"
                    placeholder="Search by business name, diner name"
                    name="search"
                    onChange={onSearchChange}
                    value={state.search}
                    className="amSearch"
                  />
                </>
              </ZoomDiv>
            </div>
          )}
          {filter && (
            <div className="container-fluid">
              <div className="enWhiteBox mt-3">
                <Form className="row justify-content-between">
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Offer">
                          {selectedTab === 2
                            ? "Offer type"
                            : selectedTab === 3
                            ? "Event type"
                            : selectedTab === 4
                            ? "Live Streaming Platforms"
                            : "Filter"}
                        </InputLabel>
                        <Select
                          value={filterOptionTemp}
                          onChange={(e) => setFilterOptionTemp(e.target.value)}
                          label="Offer"
                          inputProps={{
                            name: "Offer",
                            id: "outlined-Location",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {selectedTab === 2 || selectedTab === 3
                            ? offer_filters.map((data) => {
                                return (
                                  <option value={data.value} key={data.title}>
                                    {data.title}
                                  </option>
                                );
                              })
                            : null}
                          {selectedTab === 4
                            ? live_streaming_filters.map((data) => {
                                return (
                                  <option value={data.value} key={data.title}>
                                    {data.title}
                                  </option>
                                );
                              })
                            : null}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                  <Col>
                    <div className="d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5"
                        onClick={() => setFilter(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={() => {
                          setFilterOption(filterOptionTemp);
                          setFilter(false);
                        }}
                        // onClick={searchClick}
                      >
                        Search
                      </Button>
                    </div>
                  </Col>
                </Form>
              </div>
            </div>
          )}
          <hr  className="m-0"/>
          <div className="super-admin-rating-review-tab super-admin-issues-open-users-tab">
            <div className="ml-4">
              <div className="d-flex align-items-center">
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    selectedTab === 1 ? "active" : ""
                  }`}
                  onClick={() => pageChangeButtonHandler(1)}
                >
                  Restaurants
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    selectedTab === 2 ? "active" : ""
                  }`}
                  onClick={() => pageChangeButtonHandler(2)}
                >
                  Offers
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    selectedTab === 3 ? "active" : ""
                  }`}
                  onClick={() => pageChangeButtonHandler(3)}
                >
                  Events
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    selectedTab === 4 ? "active" : ""
                  }`}
                  onClick={() => pageChangeButtonHandler(4)}
                >
                  Live Streaming
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    selectedTab === 5 ? "active" : ""
                  }`}
                  onClick={() => pageChangeButtonHandler(5)}
                >
                  Items
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    selectedTab === 6 ? "active" : ""
                  }`}
                  onClick={() => pageChangeButtonHandler(6)}
                >
                  Video Tracker
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    selectedTab === 7 ? "active" : ""
                  }`}
                  onClick={() => pageChangeButtonHandler(7)}
                >
                  Reels
                </Button>
              </div>
            </div>
          </div>
          <div className="super-admin-inside-right-side-panel">
            {selectedTab === 1 ? (
              <UserFavoritesRestaurant
                pageChanger={pageChangeButtonHandler}
                selectedTab={selectedTab}
                dateQuery={dateQuery}
                search={state.search}
                sortValue={state.restaurantReverse}
                filterOption={filterOption}
              />
            ) : null || selectedTab === 2 ? (
              <UserFavoritesOffers
                pageChanger={pageChangeButtonHandler}
                selectedTab={selectedTab}
                dateQuery={dateQuery}
                search={state.search}
                sortValue={state.restaurantReverse}
                filterOption={filterOption}
              />
            ) : null || selectedTab === 3 ? (
              <UserFavoritesEvents
                pageChanger={pageChangeButtonHandler}
                selectedTab={selectedTab}
                dateQuery={dateQuery}
                search={state.search}
                sortValue={state.restaurantReverse}
                filterOption={filterOption}
              />
            ) : null || selectedTab === 4 ? (
              <UserFavoritesLiveStreaming
                pageChanger={pageChangeButtonHandler}
                selectedTab={selectedTab}
                dateQuery={dateQuery}
                search={state.search}
                sortValue={state.restaurantReverse}
                filterOption={filterOption}
              />
            ) : null || selectedTab === 5 ? (
              <UserItemActivity
                pageChanger={pageChangeButtonHandler}
                selectedTab={selectedTab}
                dateQuery={dateQuery}
                search={state.search}
                sortValue={state.restaurantReverse}
                filterOption={filterOption}
              />
            ) : null || selectedTab === 6 ? (
              <UserTrackVideo
                pageChanger={pageChangeButtonHandler}
                selectedTab={selectedTab}
                dateQuery={dateQuery}
                search={state.search}
                sortValue={state.restaurantReverse}
                filterOption={filterOption}
              />
            ) : null || selectedTab === 7 ? (
              <UserFavoriteReels
                pageChanger={pageChangeButtonHandler}
                selectedTab={selectedTab}
                dateQuery={dateQuery}
                search={state.search}
                sortValue={state.restaurantReverse}
                filterOption={filterOption}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

// export default SuperAdminUserViewUsed;

SuperAdminUserViewUsed.propTypes = {
  auth: PropTypes.object.isRequired,
  getUserActivity: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  userItemActivity: state.userManagement.userItemActivity,
  userOfferActivity: state.userManagement.userOfferActivity,
  userEventActivity: state.userManagement.userEventActivity,
  userStreamingActivity: state.userManagement.userStreamingActivity,
  userRestaurantActivity: state.userManagement.userRestaurantActivity,
});

export default connect(mapStateToProps, null)(SuperAdminUserViewUsed);
